import styled from 'styled-components';
import media from '../../../styles/theme/breakpoints';

const WorkRoomBoardWrapper = styled.div`
  background: ${({ theme }) => theme.colors.neutral[0]};

  #Board_View {
    margin-bottom: ${({ theme }) => theme.spacing[12]};
  }

  table {
    width: 100%;
    border-spacing: 0;
    border-radius: ${({ theme }) => theme.borderRadius.base};
    overflow: hidden;
    box-shadow: ${({ theme }) => theme.elevation.base};
  }

  .QA_게시판 {
    thead {
      background: ${({ theme }) => theme.colors.neutral[100]};
    }

    th, td {
      padding: ${({ theme }) => theme.spacing[4]};
      border-bottom: 1px solid ${({ theme }) => theme.colors.neutral[200]};
    }

    th {
      font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
      color: ${({ theme }) => theme.colors.neutral[700]};
      font-size: ${({ theme }) => theme.typography.fontSize.sm};
    }

    tbody tr:hover {
      background: ${({ theme }) => theme.colors.neutral[50]};
    }

    a, button {
      color: ${({ theme }) => theme.colors.primary[500]};
      cursor: pointer;
      &:hover { color: ${({ theme }) => theme.colors.primary[700]}; }
    }
  }

  .WriteButton {
    width: 100%;
    height: 50px;
    margin-top: ${({ theme }) => theme.spacing[4]};
    background: ${({ theme }) => theme.colors.primary[500]};
    color: ${({ theme }) => theme.colors.neutral[0]};
    border: none;
    border-radius: ${({ theme }) => theme.borderRadius.base};
    font-weight: ${({ theme }) => theme.typography.fontWeight.medium};
    cursor: pointer;
    transition: background ${({ theme }) => theme.transition.fast};

    &:hover { background: ${({ theme }) => theme.colors.primary[700]}; }
  }

  .pagination {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: ${({ theme }) => theme.spacing[1]};
    margin: ${({ theme }) => theme.spacing[8]} 0;

    a {
      padding: ${({ theme }) => `${theme.spacing[2]} ${theme.spacing[3]}`};
      border-radius: ${({ theme }) => theme.borderRadius.base};
      border: 1px solid ${({ theme }) => theme.colors.neutral[200]};
      background: ${({ theme }) => theme.colors.neutral[0]};
      color: ${({ theme }) => theme.colors.neutral[700]};
      cursor: pointer;
      transition: background ${({ theme }) => theme.transition.fast};

      &:hover {
        background: ${({ theme }) => theme.colors.neutral[100]};
      }
    }

    label {
      cursor: pointer;
    }
  }

  .Contents_Deactive {
    display: none;
  }

  .Contents_Active {
    background: ${({ theme }) => theme.colors.neutral[0]};
    border-radius: ${({ theme }) => theme.borderRadius.base};
    box-shadow: ${({ theme }) => theme.elevation.base};
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin: ${({ theme }) => theme.spacing[4]} 0;
    overflow: hidden;
  }

  .ContentsBox {
    padding: ${({ theme }) => theme.spacing[5]};
    min-height: 200px;
    flex: 1;

    #Text { text-align: left; }
  }

  .CommentBox {
    padding: ${({ theme }) => theme.spacing[4]};
    flex: 2;
    min-height: 80px;
    background: ${({ theme }) => theme.colors.neutral[50]};
    border-top: 1px solid ${({ theme }) => theme.colors.neutral[200]};
  }

  .BodyText {
    padding: 0 ${({ theme }) => theme.spacing[10]};
    overflow: hidden;
    overflow-wrap: anywhere;
  }

  .TabControl {
    max-width: ${({ theme }) => theme.layout.maxWidth};
    height: 100%;
    justify-content: center;
    flex-wrap: wrap;
    list-style-type: none;
    margin: 0;
    padding: 0;
  }

  .TabPage, .TabPageBig {
    justify-content: center;
    align-items: center;

    li a {
      display: block;
      text-align: center;
      padding: ${({ theme }) => `${theme.spacing[3]} ${theme.spacing[4]}`};
      text-decoration: none;
      color: ${({ theme }) => theme.colors.neutral[700]};
      transition: color ${({ theme }) => theme.transition.fast};
    }

    li a:hover {
      color: ${({ theme }) => theme.colors.neutral[400]};
    }

    .TabActive {
      color: ${({ theme }) => theme.colors.primary[500]};
      font-weight: ${({ theme }) => theme.typography.fontWeight.bold};
    }
  }

  .TabPageBig {
    max-width: ${({ theme }) => theme.layout.maxWidth};
  }

  .SubNav {
    max-width: ${({ theme }) => theme.layout.maxWidth};
    list-style-type: none;
    margin: 0;
    padding: 0;
    overflow: hidden;
  }

  .SubNavCategory {
    list-style-type: none;
    margin: 0;
    padding: 0;
    overflow: hidden;
    background: ${({ theme }) => theme.colors.neutral[0]};

    li { float: left; }
  }

  .SubNavLeft {
    list-style-type: none;
    margin: 0;
    padding: 0;
    overflow: hidden;
    background: ${({ theme }) => theme.colors.neutral[0]};

    li { float: left; }
  }

  .SubTabPage {
    list-style-type: none;
    margin: 0;
    padding: 0;
    overflow: hidden;

    li {
      float: left;
      cursor: pointer;

      a { cursor: pointer; }
    }
  }

  .본문입력기 {
    width: 100%;
    min-height: 250px;
  }

  .ql-size-huge { font-size: 36px; }
  .ql-size-large { font-size: 26px; }
  .ql-size-small { font-size: 10px; }

  #indicater a { font-size: 18pt; }

  #WriteCondition {
    input, select {
      font-size: ${({ theme }) => theme.typography.fontSize.sm};
      line-height: 25px;
    }
  }

  ${media.laptop} {
    .Contents_Active {
      width: 100%;
      box-shadow: none;
    }

    .TabControl {
      width: 100%;
      align-items: baseline;
    }

    .SubNavCategory, .SubNav {
      width: 100%;
    }

    .본문입력기 {
      min-height: 100px;
    }

    #WriteCondition {
      width: 100%;
      font-size: ${({ theme }) => theme.typography.fontSize.xs};
      text-align: center;
    }
  }

  ${media.mobile} {
    .SubNav {
      display: inline-flex;
      justify-content: space-between;
      flex-wrap: wrap;
      width: 100%;
    }

    .TabPage {
      width: 100%;
    }

    #WriteCondition {
      font-size: ${({ theme }) => theme.typography.fontSize.xs};

      input, select {
        font-size: ${({ theme }) => theme.typography.fontSize.xs};
      }
    }
  }
`;

export default WorkRoomBoardWrapper;
